<div class="container_dialog">
    <div class="header_popup header_popup_center">
      <div class="title_popup title_popup_center">
        <span>{{"Catalogs.catalog_informations"|translate}}</span>
      </div>
      <button (click)="closed()">
        <mat-icon style="color: black;">close</mat-icon>
      </button>
    </div>
    <form class="display_form" [formGroup]="form">
      <div class="image_block">
        <div class="content_img" (change)="getCatalogImg($event)">
          <input class="file" type="file" id="upload" accept="image/jpeg, image/png, image/gif" [disabled]="!canSubmit">
          <img class="icon_user"
            [src]="imageCatalog ? 'data:;base64,' + imageCatalog : defaultVariantAvatar" for="upload"
              alt="">
          <ng-container *ngIf="imageCatalog">
            <button class="cancel_upl" *appHasPermission="submitPermission()" (click)="cancelImage()">
                <mat-icon class="cancel_icon">cancel</mat-icon>
            </button>
          </ng-container>
        </div>
      </div>
      <div class="input_field">
        <label>{{"common.name"|translate}}</label>
        <input
          class="input"
          type="text"
          formControlName="name"
          [placeholder]="'common.name'|translate"
        />
        <span class="error_ms" *ngIf="form.get('name')?.touched && form.get('name')?.errors">{{"common.required_field"|translate}}</span>
      </div>
      <div class="input_field">
        <label for="">
      {{"common.start_date"|translate}}
        </label>
        <input type="date" formControlName="start_date">
        <span class="error_ms" *ngIf="form.get('start_date')?.touched && !form.get('start_date')?.value && form.get('start_date')?.errors">
          {{"common.required_field" | translate}}
        </span>
        <span class="error_ms" *ngIf="form.get('start_date')?.value && form.get('start_date')?.hasError('startDateInvalid')">
        {{"Catalogs.start_date_must_be_today_or_later"|translate}}
        </span>
      </div>
      <div class="input_field">
        <label for="" class="slide_label">
          <mat-slide-toggle [(ngModel)]="disableDate" (change)="onToggleChange()" [disabled]="!canSubmit" [ngModelOptions]="{standalone: true}">
          </mat-slide-toggle>
          {{"common.end_date"|translate}}
        </label>
        <input type="date" formControlName="end_date">
        <span class="error_ms" *ngIf="form.get('end_date')?.value && form.get('end_date')?.hasError('endDateInvalid')">{{"Catalogs.end_date_must"|translate}}</span>
      </div>
      <div class="input_field">
        <label for="">{{"common.status"|translate}}</label>
        <select name="" id="" formControlName="status">
          <option selected value="" disabled>{{"common.status"|translate}}</option>
          <option selected value="Draft">{{"Catalogs.draft"|translate}}</option>
          <option selected value="Approved">{{"Catalogs.approved"|translate}}</option>
          <option selected value="Inactive">{{"Catalogs.inactive"|translate}}</option>
        </select>
        <span class="error_ms" *ngIf="form.get('status')?.touched && form.get('status')?.errors">{{"common.required_field"|translate}}</span>
      </div>
    </form>
    <div class="submet_btns">
      <button class="save_btn_pop_up cancel_btn_pop_up" (click)="closed()">
        <span>{{"common.back"|translate | uppercase}}</span>
        <img src="../../../../../assets/icones/arrow_back.svg" alt="">
      </button>
      <button class="save_btn_pop_up blue_btn" *appHasPermission="submitPermission()" (click)="save()">
        <span> {{"common.save"|translate | uppercase}}</span>
        <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
      </button>
    </div>
  </div>
